export default __webpack_public_path__ + "static/media/ANSIA_ICONA.6f9f49c3.svg";